export const phoneNumberInputStyleInherit = {
  padding: "0px 16px",
  width: "100%",
  height: "var(--input-height)",
  border: "1px solid", // var(--chakra-colors-chakra-border-color)",
  borderColor: "var(--chakra-colors-chakra-border-color",
  borderRadius: "var(--input-border-radius)",
};
